import styled, { css } from "styled-components";
import { Col } from "@commonlibs";

export const TitledContentBody = styled(Col)(
    ({ theme }) => css`
        padding: ${theme.spacing[8]};
        ${theme.breakpoints.down("mobile")} {
            padding: ${theme.spacing[6]};
        }
    `,
);

export const TitledContentHeder = styled(Col)(
    ({ theme }) => css`
        padding: ${theme.spacing[5]};
        ${theme.breakpoints.down("mobile")} {
            padding: ${theme.spacing[4]};
        }
    `,
);
